import api from '@/utils/api';

/**
 * Add a new variant to an existing option
 * @param {string} companyId - The company ID
 * @param {object} variantData - The variant data
 * @param {string} variantData.name - Variant name
 * @param {string} variantData.price_id - Price ID for the variant
 * @param {string} variantData.description - Variant description
 * @param {string} [variantData.quote_description] - Quote description
 * @param {string} [variantData.brochure_link] - Brochure link
 * @param {string} [variantData.video_link] - Video link
 * @param {string} [variantData.thumbnail] - Thumbnail image
 * @param {Array} [variantData.media] - Media gallery
 * @param {Array<string>} [variantData.overrides] - Field overrides
 * @param {boolean} [variantData.is_default] - Whether this is the default variant
 * @returns {Promise}
 */
const addOptionVariantApi = (companyId, variantData) =>
  api.post(`/company/${companyId}/option/variant/`, variantData);

export default addOptionVariantApi;
